const earningsDrilldownEN = {
    "view": {
        "form": {
            "label": {
                  "filters": "Filters",
                  "monthRange": "Month Range",
                  "startingMonth": "Starting Month",
                  "endingMonth": "Ending Month",
                  "label": "Label",
                  "store": "Store",
                  "release": "Release",
                  "track": "Track",
                  "country": "Country",
                  "subuser": "Subuser",
                  "fetchingEarnings": "Fetching earning stats from database",
            },
            "button": {
                "generateReport": "Generate Report",
                "resetFilters": "Reset Filters",
            },
            "options": {
                "store": {
                    "selectStore": "Select Store",
                    "allStores": "All Stores",
                },
                "label": {
                    "selectLabel": "Select Label",
                },
                "country": {
                    "allCountries": "All Countries",
                },
                "release": {
                    "allReleases": "All Releases",
                },
                "track": {
                    "allTracks": "All Tracks",
                },
                "subuser": {
                    "selectSubuser": "Select Subuser",
                },
                "period": {
                    "selectMonthRange": "Select Month Range",
                    "last3Reports": "Last 3 Reports",
                    "last6Reports": "Last 6 Reports",
                    "last12Reports": "Last 12 Reports",
                    "custom": "Custom"
                }
            },
            "validation": {
                "monthRangeRequired": "* Month Range filter is required",
                "labelRequired": "* Label filter is required"
            },
        },
        "royaltiesSummary": {
            "title": "Royalties Summary",
            "subtitle": "Overview of selected Month Range",
            "label": {
                "monthRangeText": "Last 12 Statements",
                "revenueEUR": "Revenue (€)",
                "combinedRevenue": "Combined Revenue",
                "combinedRevenueEUR": "Combined Revenue (€)",
                "otherStores": "Other Stores"
            },
        },
        "storeWiseRevenuePercentage": {
            "title":  "Store-wise Revenue Percentage"
        },
        "storeWiseRevenueBreakdown": {
            "title": "Store-wise Revenue Breakdown",
            "label": {
                "revenue": "Revenue"
            }
        },
        "revenueByTerritory": {
            "title": "Revenue By Territory"
        },
        "top5Releases": {
            "title": "Top 5 Releases",
            "table": {
                "column": {
                    "releaseName": "Release Name",
                    "revenue": "Revenue"
                }
            }
        },
        "top5Tracks": {
            "title": "Top 5 Tracks",
            "table": {
                "column": {
                    "trackName": "Track Name",
                    "revenue": "Revenue"
                }
            }
        },
        "message": {
            "noAccess": "You don't have access to this module, please contact the support team for further information.",
            "subscriptionExpired": "Your subscription has expired. Please <1>resume</1> your subscription to avail this feature.",
            "subscriptionUpgrade": "Your current subscription plan does not support this feature. Please <1>upgrade</1> your subscription plan to avail this feature.",
        }
    }
};

export default earningsDrilldownEN;